import loadable from '@loadable/component';

export const Youtube = loadable(() => import('./YoutubeBase'));
